/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, COMMON, MORE_MENU_SCREEN, API_CONSTANTS, PERMISSION_CONSTANTS, SYNC_SERVICE, APP_INFO, APP_CONSTANTS } from '../../global/Constants';
import './more-menu.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
import MyProfilePage from './MyProfilePage';
import NotificationPage from './NotificationPage';
import ChangePasswordPage from './ChangePasswordPage';
import SendFeedbackPage from './SendFeedbackPage';
import AboutTheAppPage from './AboutTheAppPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import { MORE_MENU_TYPES } from '../../global/Enum';
import Utilities from '../../global/Utilities';
import ApiServices from '../../providers/ApiServices';
import Loader from '../common/loader/Loader';
import { toast } from 'react-toastify';
import SyncServices from '../../providers/SyncServices';
import SyncLoader from '../common/loader/SyncLoader';
import RetailerRegistrationPage from './RetailerRegistrationPage';
import DataProvider from '../../providers/DataProvider';
import AuthService from '../../providers/AuthService';
import ContactUsPage from './ContactUsPage';

class MoreMenuPage extends Component {

    constructor(props) {
        super(props);
        this.count = 0;
        this._sendToParent = this._sendToParent.bind(this);
        this.state = {
            loading: false,
            unreadCount: 0,
            type: 'text',
            activeTab: MORE_MENU_TYPES.MY_PROFILE,
            isMobile: false,
            name: "",
            email: "",
            profileImage: null,
            isAssignCropGroup: false,
            selectedData: null,
            localDataCount: 0
        }
    }

    componentDidMount() {
        const session = AuthService.getSession();
        if (session) {
            toast.configure();
            this.getUserById();
            this.checkLocalData();
            const { selectedTab } = this.props;
            if (this.props.location.state) {
                this.setState({
                    activeTab: selectedTab,
                    isMobile: this.props.location.state.detail
                })
            }

            this.setState({
                isAssignCropGroup: this.checkVegCrops()
            })
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    checkVegCrops = () => {
        const cropGroups = DataProvider.getInstance().getCropGroups();
        Utilities.LogPrint("CropGroups", cropGroups);
        if (cropGroups.length > 0) {
            //Utilities.LogPrint("CropGroups In Menu", cropGroups?.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS));
            //return cropGroups?.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS);
            return true;
        } else {
            return false;
        }
    }

    checkLocalData = () => {
        SyncServices.getLocalKrishakCount().then(krishakCount => {

            if (krishakCount > 0) {
                this.count = this.count + krishakCount;
                SyncServices.getLocalActivityCount().then(activityCount => {
                    this.count = this.count + activityCount;
                });

            } else {
                SyncServices.getLocalActivityCount().then(activityCount => {
                    //Utilities.LogPrint("COUNT Activity = ", activityCount);
                    this.count = activityCount;
                });
            }
        });

        // SyncServices.getLocalActivityCount().then(activityCount => {
        //     Utilities.LogPrint("COUNT Activity = ", activityCount);
        // });
    }

    getUserById = () => {
        const session = AuthService.getSession();
        if (session !== null) {
            const user = session?.user;
            this.setState({
                name: user.name,
                email: user.email,
                profileImage: user.profile_pic
            });
        }
    }

    _handleLogout = (e) => {
        if (Utilities.isNetworkConnected()) {
            if (this.count === 0) {
                this.setState({ loading: true });
                e.preventDefault();
                try {
                    ApiServices.logout()
                        .then(response => {
                            this.setState({ loading: false });
                            var status = response.success;
                            if (status) {
                                SyncServices.clearAllData();
                                this.clearSessionData();
                                this.props.history.push(ALL_ROUTES.SIGN_IN_ROUTE);
                            } else {
                                if (response.message === COMMON.TOKEN_EXPIRED) {
                                    Utilities.tokenExpiredRedirectToLogin();
                                }
                            }
                        }).catch(error => {
                            this.setState({ loading: false });
                        });
                } catch (error) {
                    this.setState({ loading: false });
                }
            } else {
                toast.info(COMMON.LOGOUT_MESSAGE);
            }

        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    clearSessionData = () => {
        localStorage.setItem(SYNC_SERVICE.LAST_SYNC_DATE, null);
        localStorage.setItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE, null);
        localStorage.setItem('reloaded', "false");
        localStorage.removeItem(APP_CONSTANTS.RETAILER);
        localStorage.removeItem(API_CONSTANTS.ACCESS_TOKEN);
        AuthService.clearSession();
    }

    _handleActivityDetails = () => {
        this.props.history.push(ALL_ROUTES.ACTIVITYDETAILS_ROUTE);
    }

    getInitialState = () => {
        return {
            type: 'text'
        };
    }
    onFocus = () => {
        this.setState({
            type: 'date'
        });
    }

    onBlur = () => {
        this.setState({
            type: 'text'
        });
    }

    _sendToParent(isMobile) {
        this.setState({
            isMobile: isMobile,
        })

        this.props.history.replace(ALL_ROUTES.MORE_MENU_ROUTE);
    }

    _handleTab(tabName) {
        //const { isMobile } = this.state;
        this.setState({
            activeTab: tabName,
            isMobile: !this.state.isMobile,
        });
        switch (tabName) {
            case MORE_MENU_TYPES.MY_PROFILE:
                this.props.history.replace({
                    pathname: ALL_ROUTES.MY_PROFILE_ROUTE,
                    state: { detail: true, activeTab: MORE_MENU_TYPES.MY_PROFILE }
                })
                break;
            case MORE_MENU_TYPES.NOTIFICATION:
                this.props.history.replace({
                    pathname: ALL_ROUTES.NOTIFICATIONS_ROUTE,
                    state: { detail: true, activeTab: MORE_MENU_TYPES.NOTIFICATION }
                })
                break;
            case MORE_MENU_TYPES.RETAILER_REGISTRATION:
                this.props.history.replace({
                    pathname: ALL_ROUTES.RETAILER_REGISTRATION_ROUTE,
                    state: { detail: true }
                });
                break;
            case MORE_MENU_TYPES.CHANGE_PASSWORD:
                this.props.history.replace({
                    pathname: ALL_ROUTES.CHANGE_PASSWORD_ROUTE,
                    state: { detail: true }
                })
                break;
            case MORE_MENU_TYPES.CONTACT_US:
                this.props.history.replace({
                    pathname: ALL_ROUTES.CONTACT_US_ROUTE,
                    state: { detail: true, activeTab: MORE_MENU_TYPES.CONTACT_US }
                })
                break;
            case MORE_MENU_TYPES.SEND_FEEDBACK:
                this.props.history.replace({
                    pathname: ALL_ROUTES.SEND_FEEDBACK_ROUTE,
                    state: { detail: true, selectedData: this.state.selectedData, activeTab: MORE_MENU_TYPES.SEND_FEEDBACK }
                })
                break;
            case MORE_MENU_TYPES.ABOUT_THE_APP:
                this.props.history.replace({
                    pathname: ALL_ROUTES.ABOUT_THE_APP_ROUTE,
                    state: { detail: true }
                })
                break;
            case MORE_MENU_TYPES.PRIVACY_POLICY:
                this.props.history.replace({
                    pathname: ALL_ROUTES.PRIVACY_POLICY_ROUTE,
                    state: { detail: true }
                })
                break;
            default:
                break;
        }
    }

    loaderCallback = (loading) => {
        this.setState({ loading })
    }

    setNotificationCount = (unreadCount) => {
        this.setState({ unreadCount })
    }

    handleSendFeedback = (selectedData) => {
        this.setState({ selectedData })
        this._handleTab(MORE_MENU_TYPES.SEND_FEEDBACK)
    }

    handleGalleryCLick = () => {
        document.getElementById('profileFile').click();
    }

    uploadProfileImage(file) {
        const formData = new FormData();
        formData.append("image", file);
        try {
            ApiServices.updateUserImage(formData)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                    } else {
                        alert(response.message);
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    // On file select (from the pop up)
    onFileChange = event => {

        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({
                    profileImage: e.target.result
                })
                this.uploadProfileImage(event.target.files[0]);
                event.target.value = null;
            };
            reader.readAsDataURL(event.target.files[0]);


            Utilities.LogPrint("Selected Image: ---- >", event.target.files[0]);
        }
    };

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    handleSync = () => {
        this.checkLocalData();
    }

    handleDaksh = () => {
        this.props.history.push(ALL_ROUTES.DAKSH_ROUTE);
    }

    handleDakshApproval = () => {
        this.props.history.push(ALL_ROUTES.DAKSH_APPROVAL_ROUTE);
    }


    render() {
        const { activeTab, isMobile, loading, name, email, unreadCount, profileImage, isSyncLoading, tableName, isAssignCropGroup } = this.state;
        //Utilities.LogPrint("render", isMobile);

        const showRetailerRegMenu = AuthService.getRoleAccess(PERMISSION_CONSTANTS.RETAILER_REGISTRATION);
        const showDakshMenu = AuthService.getRoleAccess(PERMISSION_CONSTANTS.DAKSH);
        const showDakshApprovalMenu = AuthService.getRoleAccess(PERMISSION_CONSTANTS.DAKSH_APPROVAL);

        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} handleSync={this.handleSync} />
                <Footer isActive={4} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-lg-4 more-menuheading">
                                    <div className="desktop-profile">
                                        <div className="row align-items-center">
                                            <div className="edit-profile-img d-inline-block col-6">
                                                <img src={profileImage ? profileImage : "../assets/images/default-user.png"} className="img-fluid" alt="" />

                                                <input className="d-none" accept="image/png, image/jpeg" id="profileFile" type="file" onChange={this.onFileChange} />
                                                <i className="customic ic-edit-profile" onClick={this.handleGalleryCLick}></i>
                                            </div>
                                            <div className="col-6">
                                                <p className="email" title={email}>{email}</p>
                                                <p className="mt-0">{name}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <h6>{COMMON.MORE}</h6>
                                    <ul className="more-menu mb-0">

                                        {/* Daksh Menu */}
                                        {showDakshMenu?.view ?
                                            <li className="collapsed"
                                                onClick={this.handleDaksh}>
                                                <i className="customic more-menu-daksh mr-3"></i>
                                                <span className="gt">Daksh</span>
                                            </li> : null
                                        }

                                        {showDakshApprovalMenu?.view ?
                                            <li onClick={this.handleDakshApproval}>
                                                <i className="customic more-menu-daksh-approval mr-3"></i>
                                                <span className="gt">Daksh Approval</span>
                                            </li> : null
                                        }

                                        {showRetailerRegMenu?.view && isAssignCropGroup ?
                                            <li onClick={() => this._handleTab(MORE_MENU_TYPES.RETAILER_REGISTRATION)}>
                                                <i className="customic more-menu-retailer-reg mr-3"></i>
                                                <span className="gt">{MORE_MENU_SCREEN.RETAILER_REGISTRATION}</span>
                                            </li> : null
                                        }

                                        {showRetailerRegMenu?.view && isAssignCropGroup ?
                                            <li className="divider-li p-0"></li> : null
                                        }


                                        {/* Menu */}
                                        <li onClick={() => this._handleTab(MORE_MENU_TYPES.MY_PROFILE)} className={(activeTab === MORE_MENU_TYPES.MY_PROFILE) ? "active" : ""} data-tab="myProfile">
                                            <i className="customic more-menu-my-proflie mr-3"></i> {MORE_MENU_SCREEN.MY_PROFILE}
                                        </li>
                                        <li onClick={() => this._handleTab(MORE_MENU_TYPES.NOTIFICATION)} className={(activeTab === MORE_MENU_TYPES.NOTIFICATION) ? "active" : ""} data-tab="notifications">
                                            <i className="customic more-menu-notifications mr-3"></i> {MORE_MENU_SCREEN.NOTIFICATIONS}
                                            <span className={(unreadCount === 0 || unreadCount === null) ? "d-none" : "new-notification-count"}>{unreadCount} New</span>
                                        </li>

                                        {/* {
                                            showRetailerRegMenu?.view && isAssignCropGroup ?
                                                <li onClick={() => this._handleTab(MORE_MENU_TYPES.RETAILER_REGISTRATION)} className={(activeTab === MORE_MENU_TYPES.RETAILER_REGISTRATION) ? "active" : ""} >
                                                    <i className="customic more-menu-add-retailer mr-3"></i> {MORE_MENU_SCREEN.RETAILER_REGISTRATION}
                                                </li> : null
                                        } */}

                                        <li onClick={() => this._handleTab(MORE_MENU_TYPES.CHANGE_PASSWORD)} className={(activeTab === MORE_MENU_TYPES.CHANGE_PASSWORD) ? "active" : ""} data-tab="changePassword">
                                            <i className="customic more-menu-change-password mr-3"></i> {MORE_MENU_SCREEN.CHANGE_PASSWORD}
                                        </li>
                                        <li onClick={() => this._handleTab(MORE_MENU_TYPES.CONTACT_US)} className={(activeTab === MORE_MENU_TYPES.CONTACT_US) ? "active" : ""} data-tab="sendFeedback">
                                            <i className="customic more-menu-contact-us mr-3"></i> {MORE_MENU_SCREEN.CONTACT_US}
                                        </li>
                                        <li onClick={() => this._handleTab(MORE_MENU_TYPES.ABOUT_THE_APP)} className={(activeTab === MORE_MENU_TYPES.ABOUT_THE_APP) ? "active" : ""} data-tab="aboutTheApp">
                                            <i className="customic more-menu-about-app mr-3"></i> {MORE_MENU_SCREEN.ABOUT_THE_APP}
                                        </li>
                                        <li onClick={() => this._handleTab(MORE_MENU_TYPES.PRIVACY_POLICY)} className={(activeTab === MORE_MENU_TYPES.PRIVACY_POLICY) ? "active" : ""} data-tab="privacyPolicy">
                                            <i className="customic more-menu-privacy-policy mr-3"></i> {MORE_MENU_SCREEN.PRIVACY_POLICY}
                                        </li>
                                        <li onClick={this._handleLogout} className="logout" data-tab="privacyPolicy">
                                            <i className="customic more-menu-logout mr-3"></i> {MORE_MENU_SCREEN.LOGOUT}
                                        </li>
                                        <li style={{ float: 'right', fontSize: '11px' }}>{APP_INFO.VERSION}<br />{APP_INFO.UPDATE_ON}</li>
                                    </ul>
                                </div>
                                <div className={isMobile ? "col-lg-8 more-menu-content" : "col-lg-8 more-menu-content d-none"}>
                                    {/* myProfile */}
                                    <MyProfilePage profileImage={profileImage} loaderCallback={this.loaderCallback} isActive={(activeTab === MORE_MENU_TYPES.MY_PROFILE) ? true : false} _sendToParent={this._sendToParent} />

                                    {/* notifications */}
                                    <NotificationPage setNotificationCount={this.setNotificationCount} loaderCallback={this.loaderCallback} isActive={(activeTab === MORE_MENU_TYPES.NOTIFICATION) ? true : false} _sendToParent={this._sendToParent} />

                                    {/* changePassword */}
                                    <RetailerRegistrationPage loaderCallback={this.loaderCallback} isActive={(activeTab === MORE_MENU_TYPES.RETAILER_REGISTRATION) ? true : false} _sendToParent={this._sendToParent} />

                                    {/* changePassword */}
                                    <ChangePasswordPage loaderCallback={this.loaderCallback} isActive={(activeTab === MORE_MENU_TYPES.CHANGE_PASSWORD) ? true : false} _sendToParent={this._sendToParent} />

                                    {/* sendFeedback */}
                                    <SendFeedbackPage loaderCallback={this.loaderCallback} isActive={(activeTab === MORE_MENU_TYPES.SEND_FEEDBACK) ? true : false} _sendToParent={this._sendToParent} />

                                    {/* contactUs */}
                                    <ContactUsPage loaderCallback={this.loaderCallback} isActive={(activeTab === MORE_MENU_TYPES.CONTACT_US) ? true : false} _sendToParent={this._sendToParent} sendFeedback={this.handleSendFeedback} />

                                    {/* aboutTheApp */}
                                    <AboutTheAppPage isActive={(activeTab === MORE_MENU_TYPES.ABOUT_THE_APP) ? true : false} _sendToParent={this._sendToParent} />

                                    {/* privacyPolicy */}
                                    <PrivacyPolicyPage isActive={(activeTab === MORE_MENU_TYPES.PRIVACY_POLICY) ? true : false} _sendToParent={this._sendToParent} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* bottom drawers Crops*/}
                <div className="modal fade bottom-drawer" id="selectCropsInput" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <h6 className="font-weight-medium">Select Crops Planted</h6>
                                <ul className="selectbox-list">
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Crop 1
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Crop 2
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Crop 3
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Crop 4
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                </ul>
                                <button className="btn btn-primary w-100 mb-2" data-dismiss="modal">DONE</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* bottom drawers Hybrid*/}
                <div className="modal fade bottom-drawer" id="selectHybridInput" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <h6 className="font-weight-medium">Select US Hybrid</h6>
                                <ul className="selectbox-list">
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Hybrid 1
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Hybrid 2
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Hybrid 3
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Hybrid 4
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                </ul>
                                <button className="btn btn-primary w-100 mb-2" data-dismiss="modal">DONE</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* bottom drawers Other Hybrid*/}
                <div className="modal fade bottom-drawer" id="selectOtherHybridInput" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <h6 className="font-weight-medium">Select Other Brand Hybrid</h6>
                                <ul className="selectbox-list">
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Other Brand Hybrid 1
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Other Brand Hybrid 2
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Other Brand Hybrid 3
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Other Brand Hybrid 4
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                </ul>
                                <button className="btn btn-primary w-100 mb-2" data-dismiss="modal">DONE</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* bottom drawers Nearest Distributor/Retailer */}
                <div className="modal fade bottom-drawer" id="selectDistributorRetailerInput" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <h6 className="font-weight-medium">Select Nearest Agri Distributor/Retailer</h6>
                                <ul className="selectbox-list">
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Distributor 1
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Distributor 2
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Distributor 3
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                    <li>
                                        <label className="cutom-checkbox-container">
                                            Distributor 4
                                            <input type="checkbox" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </li>
                                </ul>
                                <button className="btn btn-primary w-100 mb-2" data-dismiss="modal">DONE</button>
                            </div>
                        </div>
                    </div>
                </div>
                <DesktopFooter />
                {loading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}

            </div>
        )
    }
}

export default withRouter(MoreMenuPage)